import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.isBuyerUsa ? _c("div", {
    staticClass: "mb-1"
  }, [_c("div", {
    class: ["text-incoterms", _vm.centered ? "text-center" : ""]
  }, [_c("div", [_vm._v(" All orders are accepted, processed, fulfilled and payment collected by a state licensed wholesaler. ")]), _c("div", [_c("span", {
    staticClass: "router-link",
    on: {
      click: function click($event) {
        _vm.dialog = true;
      }
    }
  }, [_vm._v("Who is the wholesaler in my state ?")])])]), _c(VDialog, {
    attrs: {
      width: "40rem"
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        _vm.dialog = false;
      }
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c(VCard, [_c("div", {
    staticClass: "dialog-closer"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle",
    on: {
      click: function click($event) {
        _vm.dialog = false;
      }
    }
  })], 1), _c(VCardTitle, {
    staticClass: "dialog-title --bg-black"
  }, [_vm._v("Wholesalers")]), _c(VCardText, [_c("ul", {
    staticClass: "mt-6"
  }, [_c("li", [_vm._v("NY/NJ/CA/CT: Invoer Ekke LLC in Piermont, NY")]), _c("li", [_vm._v("DC/MD/VA: International Cellars LLC in Sterling, VA")]), _c("li", [_vm._v("CO/KY/OH: Stelvio Selections in Denver, CO")]), _c("li", [_vm._v("FL: Wine Collection in Miami, FL")]), _c("li", [_vm._v("MA: Vineyard Road LLC in Framingham, MA")])])]), _c(VCardActions, [_c(VBtn, {
    on: {
      click: function click($event) {
        _vm.dialog = false;
      }
    }
  }, [_vm._v("Ok")])], 1)], 1)], 1)], 1) : _vm._e();
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };